import { Injectable, EventEmitter, Output, Directive } from '@angular/core';
import { PopupModalComponent } from '../../core/components/popupmodel.component';
import { NgbModal, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Directive()
@Injectable()
export class PopmodalService {
  modalRef: NgbModalRef;
  constructor(private modalService: NgbModal,
    public activeModal: NgbActiveModal) { }
  public content: any
  @Output() navchange = new EventEmitter();

  alert(type: string, message: string, okButtonCaption: string = "Ok"): void {
    this.modalRef = this.modalService.open(PopupModalComponent,
      { backdropClass: 'light-blue-backdrop', windowClass: 'confirm-modal' });
    this.modalRef.componentInstance.type = type;
    this.modalRef.componentInstance.message = message;
    this.modalRef.componentInstance.okButtonCaption = okButtonCaption;
  }
  confirm(message: string, okButtonCaption: string = "Ok", cancelButtonCaption: string = "Cancel"): any {
    if (okButtonCaption == '') {
      okButtonCaption = 'OK'
    }
    this.modalRef = this.modalService.open(PopupModalComponent, { backdropClass: 'light-blue-backdrop', windowClass: 'confirm-modal' });
    this.modalRef.componentInstance.type = 'confirm';
    this.modalRef.componentInstance.message = message;
    this.modalRef.componentInstance.isConfirmModal = true;
    this.modalRef.componentInstance.okButtonCaption = okButtonCaption;
    this.modalRef.componentInstance.cancelButtonCaption = cancelButtonCaption;
    return this.modalRef.componentInstance.GenericPopup;
  }
  getNavChangeEmitter() {
    return this.navchange;
  }
}
